import {
  Paper,
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";

import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { addCaseUsers, getCaseUsers } from "../../api/caseUsers";
import UserListSelector from "../../components/UserListSelector";
import useSnackbar from "../../hooks/useSnackbar";
import useErrorHandler from "../../hooks/useErrorHandler";

export default function AddCaseUsers() {
  const handleError = useErrorHandler();
  const { data: user } = useSelector((state) => state.user);

  const [addedUsers, setAddedUsers] = useState([]);
  const [availableTypes, setAvailableTypes] = useState([
    "PLAINTIFF",
    "DEFENDANT",
    "SUPPORTER",
    "ATTORNEY",
    "TRANSLATOR",
  ]);

  const [selectedUsers, setSelectedUsers] = useState([]);
  function collectUserList(data) {
    let lastIndex = data.length - 1;
    if (lastIndex >= 0) {
      let toCheck = data[lastIndex];
      if (addedUsers.some((a) => a.id === toCheck.id)) {
        snackbar.showInfo(`${toCheck.name} is already added.`);
      } else {
        let d = data.map((d) => ({
          name: d.name,
          id: d.id,
          isPrimary: false,
          type: "SUPPORTER",
          from_plaintiff: true,
        }));

        setSelectedUsers(d);
      }
    } else {
      setSelectedUsers([]);
    }
  }

  useEffect(() => {
    if (!user.token) return;
    getCaseUsers(user.token, params.id)
      .then(({ data }) => {
        setAddedUsers(
          data.data.map((d) => ({
            name: d.name,
            id: d.user_id,
            isPrimary: d.is_primary,
            type: d.type,
            from_plaintiff: d.from_plaintiff,
          }))
        );
      })
      .catch();
  }, [user.token]);

  const handleIsPrimaryChange = (value, index) => {
    setSelectedUsers((prev) =>
      prev.map((u, i) => {
        if (i === index) return { ...u, isPrimary: !u.isPrimary };
        else return u;
      })
    );
  };

  const handleTypeChange = (value, index) => {
    setSelectedUsers((prev) =>
      prev.map((u, i) => {
        if (i === index) return { ...u, type: value };
        else return u;
      })
    );
    if (value === "PLAINTIFF" || value === "DEFENDANT") {
      handleSideChange(value, index);
    }
  };

  const handleSideChange = (value, index) => {
    setSelectedUsers((prev) =>
      prev.map((u, i) => {
        if (i === index) return { ...u, from_plaintiff: value === "PLAINTIFF" };
        else return u;
      })
    );
  };

  const snackbar = useSnackbar();
  const navigate = useNavigate();
  const params = useParams();
  const handleSubmit = async () => {
    try {
      await addCaseUsers(user.token, params.id, { users: selectedUsers });
      snackbar.showSuccess("Users Added.");
      navigate(`/cases/${params.id}`, { replace: true });
    } catch (error) {
      handleError(error);
    }
  };

  return (
    <Paper className="p-4" elevation={2}>
      <Box display="flex" justifyContent="space-between" pb={2}>
        <Box width="300px">
          <UserListSelector label="Users" collectData={collectUserList} />
        </Box>
        <Box>
          {selectedUsers.length ? (
            <Button variant="contained" size="small" onClick={handleSubmit}>
              Add Users
            </Button>
          ) : (
            <></>
          )}
        </Box>
      </Box>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Side</TableCell>
              <TableCell>Primary User</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {addedUsers.map((s, i) => (
              <TableRow key={i}>
                <TableCell>{s.name}</TableCell>
                <TableCell>
                  <FormControl size="small" fullWidth>
                    <InputLabel>Type</InputLabel>
                    <Select
                      disabled
                      label="Type"
                      value={s.type}
                      onChange={() => {}}
                    >
                      {availableTypes.map((t, i) => (
                        <MenuItem key={i} value={t}>
                          {t}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </TableCell>
                <TableCell>
                  <FormControl disabled>
                    <RadioGroup
                      row
                      value={s.from_plaintiff ? "PLAINTIFF" : "DEFENDANT"}
                      onChange={() => {}}
                    >
                      <FormControlLabel
                        value="PLAINTIFF"
                        control={<Radio />}
                        label="Plaintiff"
                      />
                      <FormControlLabel
                        value="DEFENDANT"
                        control={<Radio />}
                        label="Defendant"
                      />
                    </RadioGroup>
                  </FormControl>
                </TableCell>
                <TableCell>
                  <Checkbox
                    size="small"
                    checked={s.isPrimary}
                    disabled
                    onChange={() => {}}
                  />
                </TableCell>
              </TableRow>
            ))}
            {selectedUsers.map((s, i) => (
              <TableRow key={i}>
                <TableCell>{s.name}</TableCell>
                <TableCell>
                  <FormControl size="small" fullWidth>
                    <InputLabel>Type</InputLabel>
                    <Select
                      label="Type"
                      value={s.type}
                      onChange={({ target }) =>
                        handleTypeChange(target.value, i)
                      }
                    >
                      <MenuItem value="PLAINTIFF">Plaintiff</MenuItem>
                      <MenuItem value="DEFENDANT">Defendant</MenuItem>
                      <MenuItem value="ATTORNEY">Attorney</MenuItem>
                      <MenuItem value="TRANSLATOR">Translator</MenuItem>
                      <MenuItem value="SUPPORTER">Supporter</MenuItem>
                    </Select>
                  </FormControl>
                </TableCell>
                <TableCell>
                  <FormControl>
                    <RadioGroup
                      row
                      value={s.from_plaintiff ? "PLAINTIFF" : "DEFENDANT"}
                      onChange={({ target }) =>
                        handleSideChange(target.value, i)
                      }
                    >
                      <FormControlLabel
                        value="PLAINTIFF"
                        control={<Radio />}
                        label="Plaintiff"
                      />
                      <FormControlLabel
                        value="DEFENDANT"
                        control={<Radio />}
                        label="Defendant"
                      />
                    </RadioGroup>
                  </FormControl>
                </TableCell>

                <TableCell>
                  <Checkbox
                    size="small"
                    checked={s.isPrimary}
                    onChange={({ target }) =>
                      handleIsPrimaryChange(target.value, i)
                    }
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}
